import React from 'react';

function Badge({ status }) {
  const map = {
    pending:   { cls: 'badge-pending',   icon: '⏳', label: 'Pending' },
    accepted:  { cls: 'badge-accepted',  icon: '✅', label: 'Accepted' },
    cancelled: { cls: 'badge-cancelled', icon: '❌', label: 'Cancelled' },
  };
  const b = map[status] || { cls: 'badge-inactive', icon: '?', label: status };
  return <span className={`badge ${b.cls}`}>{b.icon} {b.label}</span>;
}

/**
 * BookingCard
 * variant: 'school' | 'parent' | 'admin'
 * onAccept / onCancel / onParentCancel – optional action handlers
 */
export default function BookingCard({ booking, variant, onAccept, onCancel, onParentCancel }) {
  const { childName, childAge, date, timeSlot, schoolName, parentName,
          parentEmail, notes, status, cancelReason } = booking;

  return (
    <div className="booking-card">
      <div className="booking-card-top">
        <div>
          <div className="booking-card-title">
            {variant === 'school' || variant === 'admin' ? (
              <>👶 {childName} <span style={{ fontWeight: 400, fontSize: 14 }}>(age {childAge})</span></>
            ) : (
              <>🏫 {schoolName}</>
            )}
          </div>
          <div className="booking-card-sub">
            {variant === 'school' || variant === 'admin'
              ? <>Parent: {parentName} &middot; {parentEmail}</>
              : <>Child: {childName}, age {childAge}</>}
          </div>
          {variant === 'admin' && (
            <div className="booking-card-sub" style={{ marginTop: 2 }}>School: {schoolName}</div>
          )}
        </div>
        <Badge status={status} />
      </div>

      <div className="booking-meta">
        <span className="meta-tag">📅 {date}</span>
        <span className="meta-tag">🕐 {timeSlot}</span>
        {notes && <span className="meta-tag">📝 {notes}</span>}
      </div>

      {cancelReason && (
        <div style={{ marginTop: 10, padding: '8px 12px', background: 'var(--danger-bg)', borderRadius: 8, fontSize: 13, color: 'var(--danger)' }}>
          ⚠️ Reason: {cancelReason}
        </div>
      )}

      {/* School actions */}
      {variant === 'school' && status === 'pending' && (
        <div className="booking-card-actions">
          <button className="btn btn-success btn-sm" onClick={() => onAccept && onAccept(booking)}>✔ Accept</button>
          <button className="btn btn-danger btn-sm"  onClick={() => onCancel && onCancel(booking)}>✘ Cancel</button>
        </div>
      )}

      {/* Parent actions */}
      {variant === 'parent' && (status === 'pending' || status === 'accepted') && (
        <div className="booking-card-actions">
          <button className="btn btn-outline btn-sm" style={{ color: 'var(--danger)', borderColor: 'var(--danger)' }}
            onClick={() => onParentCancel && onParentCancel(booking)}>
            Cancel Booking
          </button>
        </div>
      )}
    </div>
  );
}
